<template>
	<div>
		<el-card>
			<div v-if="getFormConfig" slot="header">
				<span v-html="clearPLabel(getFormConfig.label)"></span>
			</div>
			<el-alert
				v-if="getFormConfig && getFormConfig.notice"
				:title="getFormConfig.notice.content"
				show-icon
				style="margin-bottom: 10px"
				type="warning"></el-alert>
			<avue-form ref="refAttach" v-model="formAttach" :option="optionAttach" :upload-error="uploadError"></avue-form>
		</el-card>
	</div>
</template>

<script>
import {baseFileAttachOption, getCompleteOption} from 'meibao-insure/src/option/baseOption'
import {clearPLabel} from 'meibao-insure/src/util/commonUtils'
import {mapGetters} from 'vuex'

export default {
	name: 'formAttach',
	components: {},
	props: {
		attachFormAllData: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			//option
			isLoading: false,
			optionAttach: {},
			formAttach: {
				attach: '',
			},
			isRequired: false,
		}
	},
	computed: {
		...mapGetters([]),
		getFormConfig() {
			if (this.validatenull(this.attachFormAllData)) {
				return ''
			}
			return this.attachFormAllData.config || {}
		},
	},
	watch: {
		attachFormAllData: {
			handler(newVal) {
				if (this.validatenull(newVal)) {
					return
				}
				//处理数据
				this.optionAttach = getCompleteOption(this.attachFormAllData, baseFileAttachOption(this.attachFormAllData))
				//判断是否必填，从attachFormAllData.attach.required
				if (this.attachFormAllData.attach) {
					this.isRequired = this.attachFormAllData.attach.required === 1
				}
			},
			immediate: true,
		},
	},
	mounted() {},
	methods: {
		clearPLabel,
		/**
		 * 设置数据
		 * @param {*} data
		 */
		onSetAttachData(attachData = []) {
			//转换为string
			this.formAttach.attach = attachData.join(',') || ''
		},
		/**
		 * 获取数据
		 * @returns
		 */
		getAttachData() {
			let tempAttach = null
			//判断是否存在,解构
			let {attach = ''} = this.formAttach
			if (attach) {
				// 将字符串转换为数组
				tempAttach = {attach: attach.split(',')}
			}
			//如果为空，则返回null
			return tempAttach
		},
		/**
		 * 判断是否必填
		 * @returns true 必填 false 非必填
		 */
		isConfirm() {
			return this.isRequired && this.getAttachData() === null
		},
		/**
		 * 上传错误
		 * @param {*} error
		 */
		uploadError(error) {
			console.log('上传失败', error)
			//如果 error 包含 size，则提示
			if (error.includes('size')) {
				this.$message.error('文件大小超过限制')
			}
			//如果 error 包含 type，则提示
			if (error.includes('type')) {
				this.$message.error('文件类型不支持')
			}
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
	padding: 20px 20px 0 20px;
}

::v-deep .el-upload-dragger {
	width: 250px;
	height: 150px;
}
</style>
